import { Breadcrumbs } from "../../../../../../../../constant/Breadcrumbs"
import { Routers } from "../../../../../../../../constant/Routers"

const { SCR221 } = Routers
const { BRCR_SCR221, BRCR_SCR221_USER } = Breadcrumbs

export const getBreadcrumbItems = (pathname: string) =>
  pathname === SCR221 ? BRCR_SCR221 : BRCR_SCR221_USER
